(function () {
  if (window.location.pathname !== "/") return;

  const normalizePath = (setHref) => {
    try {
      const url = new URL(setHref, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      if (url.pathname === "/") return "/";
      return url.pathname.endsWith("/")
        ? url.pathname.slice(0, -1)
        : url.pathname;
    } catch (e) {
      return null;
    }
  };

  const getTopModeLocalStorage = () => {
    try {
      return localStorage.getItem("topMode");
    } catch (e) {
      return null;
    }
  };

  if (!getTopModeLocalStorage()) return;

  const localStoragePath = normalizePath(getTopModeLocalStorage());
  const nowPath = normalizePath(window.location.pathname);

  if (!localStoragePath || localStoragePath === nowPath) return;

  window.location.replace(window.location.origin + localStoragePath);
})();
